import React, { Component } from 'react'
import {movies} from './getMovies'
export default class favourite extends Component {
    constructor(){
        super();
        this.state = {
            genres: [],
            currGenres: 'All Genres',
            movies:[],
            currText:"",
            limit : 5,
            currPage : 1,
        }
    }

    componentDidMount(){
        let genreids = {28:'Action',12:'Adventure',16:'Animation',35:'Comedy',80:'Crime',99:'Documentary',18:'Drama',10751:'Family',14:'Fantasy',36:'History',27:'Horror',10402:'Music',9648:'Mystery',10749:'Romance',878:'Sci-Fi',10770:'TV',53:'Thriller',10752:'War',37:'Western'};
        let data = JSON.parse(localStorage.getItem('movies') || "[]");
    
        let temp = [];
        data.forEach((movieObj)=>{
            if(!temp.includes(genreids[movieObj.genre_ids[0]])){
                temp.push(genreids[movieObj.genre_ids[0]]);
            }
        })
        temp.unshift('All Genres');

        this.setState({
            genres:[...temp],
            movies:[...data],
        })
    }

    handleGenresChange = (genres)=>{
        this.setState({
            currGenres: genres
        })
    }

    sortPopularityDesc = () =>{
        let temparr = this.state.movies;
        temparr.sort(function(objA,objB){
            return objB.popularity - objA.popularity
        })

        this.setState({
            movies: [...temparr]
        })
    }

    sortRatingDesc = () =>{
        let temparr = this.state.movies;
        temparr.sort(function(objA,objB){
            return objB.vote_average - objA.vote_average
        })

        this.setState({
            movies: [...temparr]
        })
    }

    sortPopularityAsce = () =>{
        let temparr = this.state.movies;
        temparr.sort(function(objA,objB){
            return objA.popularity - objB.popularity
        })

        this.setState({
            movies: [...temparr]
        })
    }

    sortRatingAsce = () =>{
        let temparr = this.state.movies;
        temparr.sort(function(objA,objB){
            return objA.vote_average - objB.vote_average
        })

        this.setState({
            movies: [...temparr]
        })
    }

    handlePAgeChange = (page) => {
        this.setState({
            currPage:page
        })
    }

    handleDelete = (id) =>{
        let newArr = [];
        newArr = this.state.movies.filter((movieObj)=>movieObj.id!=id)
        this.setState({
            movies:[...newArr]
        })
        localStorage.setItem('movies',JSON.stringify(newArr));
    }

    render() {
    let genreids = {28:'Action',12:'Adventure',16:'Animation',35:'Comedy',80:'Crime',99:'Documentary',18:'Drama',10751:'Family',14:'Fantasy',36:'History',27:'Horror',10402:'Music',9648:'Mystery',10749:'Romance',878:'Sci-Fi',10770:'TV',53:'Thriller',10752:'War',37:'Western'};
    let filterarr = [];

    if(this.state.currText===''){
        filterarr = this.state.movies;
    }else{
        filterarr = this.state.movies.filter((movieObj)=>{
            let title = movieObj.original_title.toLowerCase();
            return title.includes(this.state.currText.toLowerCase()); 
        })
    }

    if(this.state.currGenres!="All Genres"){
        filterarr = this.state.movies.filter((movieObj)=>genreids[movieObj.genre_ids[0]] == this.state.currGenres)
    }

    let page = Math.ceil(filterarr.length/this.state.limit);
    let pageArr = [];
    for(let i=1; i<=page; i++){
        pageArr.push(i);
    }
    let si = (this.state.currPage-1)*this.state.limit;
    let ei = si+this.state.limit;
    filterarr = filterarr.slice(si,ei);

    return (
      <div>
          <>
            <div className='main'>
                <div className='row'>
                    <div className='col-3'>
                        <ul class="list-group favourites-genres">
                            {
                                this.state.genres.map((genresName)=>(
                                    this.state.currGenres ==  genresName ? 
                                    <li class="list-group-item" style={{backgroundColor:'#3f51b5',color:'white',fontWeight:'bold'}}>{genresName}</li> :
                                    <li class="list-group-item" style={{backgroundColor:'white',cursor:'pointer'}} onClick={()=>this.handleGenresChange(genresName)}>{genresName}</li>
                                ))
                            }
                        </ul>
                    </div>
                    <div className='col-9 favourites-table'>
                        <div className='row'>
                            <input type="text" placeholder='Search' className='input-group-text col' value={this.state.currText} onChange={(e)=> this.setState({currText:e.target.value})}/>
                            <input type="text" placeholder='Number of movies' className='input-group-text col' value={this.state.limit} onChange={(e)=>this.setState({limit:e.target.value})}/>
                        </div>
                        <div className='row'>
                            <table class="table">
                                <thead>
                                    <tr>
                                    <th scope="col">Title</th>
                                    <th scope="col">Genres</th>
                                    <th scope="col"><i class="fa-solid fa-caret-up" onClick={this.sortPopularityDesc}></i>Popularity<i class="fa-solid fa-caret-down" onClick={this.sortPopularityAsce}></i></th>
                                    <th scope="col"><i class="fa-solid fa-caret-up" onClick={this.sortRatingDesc}></i>Rating<i class="fa-solid fa-caret-down" onClick={this.sortRatingAsce}></i></th>
                                    <th scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        filterarr.map((movieObj)=>(
                                            <tr>
                                                <td><img src={`https://image.tmdb.org/t/p/original${movieObj.backdrop_path}`} style={{width:'10rem',marginRight:'0.5rem'}} alt={movieObj.title} />{movieObj.original_title}</td>
                                                <td>{genreids[movieObj.genre_ids[0]]}</td>
                                                <td>{movieObj.popularity}</td>
                                                <td>{movieObj.vote_average}</td>
                                                <td><button type="button" class="btn btn-danger" onClick={()=>this.handleDelete(movieObj.id)}>Delete</button></td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                        <nav aria-label="Page navigation example">
                            <ul class="pagination">
                                {
                                    pageArr.map((page)=>(
                                        <li class="page-item"><a class="page-link" onClick={()=>this.handlePAgeChange(page)}>{page}</a></li>
                                    ))
                                }
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
          </>
      </div>
    )
  }
}
